// Image assets for Knorr Recipe Builder
// All assets are stored locally in public/assets/

export const images = {
  // Logo
  knorrLogo: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/knorr-logo.webp",
  
  //Knorr Banner
  // knorrBanner: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/new_banner_knorr.webp",
  // knorrBanner: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/new_dinner_banner_knorr.webp",
  knorrBanner: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/knorr-banner-2026-07-10.webp",

  // knorrBanner: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/new_dinner_banner_knorr.webp",
  knorrLunchLogo: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/knorr-lunchbox-logo.webp",

  // Daraz logo:
  darazlogo: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/daraz-logo.svg",

  // FoodPanda logo:
  foodPandaLogo: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/pandamart_logo_pink.webp",
  foodPandaLogoHovered: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/pandamart_logo_white.webp",
  // Top bar background
  topBarBg: "/assets/icons/topbar-bg.svg",
  
  // QR Code
  qrCode: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/QRcode.svg",
  
  // Recipe images
  christmasFood: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/christmas-food.webp",
  chickenSalad: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/chicken-salad.webp",
  veganMeal: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/vegan-meal.webp",
  chickenSkewers: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/chicken-skewers.webp",
  dumplings: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/dumplings.webp",
  lasagna: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/lasagna.webp",
  lavaKebab: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/lava%20kebab.webp",
  shakshuka: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/shakshuka.webp",
  pasta: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/marry-me.webp",
  palak: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/palak_chaat.webp",
  tenders: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/chicken_tenders.webp",
  // Icons
  clockIcon: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/clock-icon.svg",
  kitchenIcon: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/kitchen-icon.png",
  
  // Social icons
  facebookIcon: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/facebook-icon.svg",
  instagramIcon: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/instagram-icon.svg",
  youtubeIcon: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/youtube-icon.svg",
  tiktokIcon: "https://storage.googleapis.com/promohub-public-assets/Knorr-React/tiktok-icon.svg",
  
  // Footer background
  footerBg: "/assets/icons/footer-bg.svg",
};

export default images;

